import { useQuery } from '@tanstack/react-query';
import {
  ProjectsApi,
  ProjectSearchRequest,
} from 'osep-generator-service-client-v1';
import { PROJECTS_QUERY_KEY } from '../../utils/consts';
import { useApiConfig } from '../useApiConfig';

function useProjects(
  projectSearchRequest: ProjectSearchRequest,
  refetchInterval?: number,
) {
  const { getApiConfig, axiosInstance } = useApiConfig();

  return useQuery({
    queryKey: [PROJECTS_QUERY_KEY, projectSearchRequest],
    queryFn: async () => {
      const config = await getApiConfig();
      const api = new ProjectsApi(config, undefined, axiosInstance);

      const result = (await api.searchProjects(projectSearchRequest)).data;

      return result;
    },
    refetchInterval,
  });
}

export default useProjects;
